import type { SxProps, Theme } from '@mui/material';

/** Shared unread signal — coral accent, distinct from primary nav/actions. */
export const chatUnreadBadgeSx = (size: 'nav' | 'list'): SxProps<Theme> => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  height: size === 'nav' ? 18 : 20,
  minWidth: size === 'nav' ? 18 : 20,
  px: size === 'nav' ? 0.5 : 0.625,
  borderRadius: '999px',
  fontSize: size === 'nav' ? '0.625rem' : '0.6875rem',
  fontWeight: 700,
  lineHeight: 1,
  fontVariantNumeric: 'tabular-nums',
  letterSpacing: '-0.02em',
  color: 'secondary.contrastText',
  bgcolor: 'secondary.main',
  boxShadow: (theme) =>
    `0 0 0 1px ${theme.palette.secondary.main}59, 0 2px 10px ${theme.palette.secondary.main}40`,
});

export const chatUnreadRowSx = (hasUnread: boolean): SxProps<Theme> =>
  hasUnread
    ? {
        bgcolor: 'rgba(255, 78, 113, 0.06)',
        borderLeft: '3px solid',
        borderLeftColor: 'secondary.main',
        pl: 'calc(16px - 3px)',
        '&:hover': { bgcolor: 'rgba(255, 78, 113, 0.1)' },
      }
    : {};
